module.exports = __webpack_public_path__ + "media/images/modules/publisher/steps/1-00e88b6a6aee61e8b5814f0f0ce37775.png";